<template>
    <footer>
        <h2>ShopT 2B2T</h2>
        <span>Because we love you.</span>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
    footer {
        padding: 2rem 1rem;
        color: #fff;
    }

    footer h2 {
        font-size: 2.3rem;
    }

    footer span {
        font-size: 1.2rem;
    }
</style>
